import React from 'react';

import { ButtonGroup } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import { useFiltersStateManager } from './FiltersStateManager';
import ClearButton from './components/ClearButton';
import FiltersButton from './components/FiltersButton';

const AllFiltersButton = ({ sidePage, params, badge, badgeColor }) => {
  const { onClearFilters, clear } = useFiltersStateManager();
  const [childComponent, openChildComponent] = useChildComponent();
  const handleOpen = () => {
    openChildComponent(sidePage, { params });
  };

  return (
    <React.Fragment>
      <ButtonGroup>
        <FiltersButton
          onClick={handleOpen}
          badge={badge}
          badgeColor={badgeColor}
        />
        <ClearButton onClick={onClearFilters} disabled={!clear} />
      </ButtonGroup>
      {childComponent
        ? React.cloneElement(childComponent, { params })
        : childComponent}
    </React.Fragment>
  );
};
export default AllFiltersButton;
